module.exports = __webpack_public_path__ + "img/photo.81fc2036.png";